export default {
  heading: 'oneills, san-serif',
  body: 'oneills',
  monospace: 'oneills, monospace',
  display: 'oneills, san-serif',
  googleFonts: [''],
  customFamilies: ['oneills'],
  customUrls: ['https://www.gonation.biz/fonts/oneills/oneills.css']
}
